import { useStore } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { $deposit, depositMounted } from './model'

export const useDeposit = () => {
  const { pathname } = useLocation()
  const deposit = useStore($deposit)

  React.useEffect(() => {
    depositMounted()
  }, [pathname])

  return deposit
}
